
export default () => ({
    loading: true,
    payments: null,
    currentPayment: null,
    paymentsModeGlobal: [],
    totalItems: 0,
})